export default __webpack_public_path__ + "static/media/phone.824786c1.png";